import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _class;
import { BuiltinLoading } from '@alilc/lowcode-designer';
import { engineConfig, observer } from '@alilc/lowcode-editor-core';
import { Workbench } from '@alilc/lowcode-editor-skeleton';
import { PureComponent } from 'react';
export * from '../context/base-context';
export var EditorView = observer(_class = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(EditorView, _PureComponent);
  function EditorView() {
    return _PureComponent.apply(this, arguments) || this;
  }
  var _proto = EditorView.prototype;
  _proto.render = function render() {
    var active = this.props.active;
    var editorView = this.props.editorView;
    var skeleton = editorView.innerSkeleton;
    if (!editorView.isInit) {
      var Loading = engineConfig.get('loadingComponent', BuiltinLoading);
      return /*#__PURE__*/React.createElement(Loading, null);
    }
    return /*#__PURE__*/React.createElement(Workbench, {
      skeleton: skeleton,
      className: active ? 'active engine-editor-view' : 'engine-editor-view',
      topAreaItemClassName: "engine-actionitem"
    });
  };
  return EditorView;
}(PureComponent)) || _class;